// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Careers-page-TWS86 {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.Careers-wrap-i2dc5 {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.Careers-sec-jDSqP {
  padding: 56px 0;
}

.Careers-alt-AeRCA {
  background: #f7f8f9;
}

.Careers-h2-bb89p {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 28px;
}

.Careers-h2Left-iOr11 {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 0 0 8px;
}

/* Mission */

.Careers-mission-JRhdE {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.Careers-mission-JRhdE .Careers-h2-bb89p {
  margin-bottom: 14px;
}

.Careers-missionText-dGHGA {
  font-size: 18px;
  line-height: 1.65;
  color: var(--muted);
  margin: 0;
}

/* Value cards */

.Careers-grid-gQfzI {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.Careers-card-FAsqC {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 22px;
  background: #fff;
}

.Careers-cardIc-FWWAQ {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #fff0ef;
  color: var(--red);
  margin-bottom: 14px;
}

.Careers-cardIc-FWWAQ svg {
  width: 26px;
  height: 26px;
}

.Careers-cardTitle-vZ4RF {
  font-size: 17px;
  font-weight: 800;
  margin: 0 0 8px;
}

.Careers-cardText-doWJz {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

/* Why grid */

.Careers-whyGrid-LVLUZ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.Careers-whyCard-zsnb1 {
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 26px 24px;
  background: #fff;
}

.Careers-whyTitle-Ov88I {
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 8px;
  color: var(--red);
}

.Careers-whyText-AKibF {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

/* Open application card */

.Careers-openCard-vRnig {
  max-width: 720px;
  margin: 0 auto;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 36px 38px;
  background: #e4f6f3;
  text-align: center;
}

.Careers-openText-Sz3Th {
  font-size: 16px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0 0 22px;
}

.Careers-openActions-tz9AB {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.Careers-openBtn-QnJBN {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  background: var(--red);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.Careers-openBtn-QnJBN:hover {
  background: var(--red-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.Careers-openBtnAlt-l4CaN {
  color: var(--ink);
  font-weight: 700;
  text-decoration: none;
  font-size: 15px;
}

.Careers-openBtnAlt-l4CaN:hover {
  text-decoration: underline;
}

@media (max-width: 1000px) {
  .Careers-grid-gQfzI {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 760px) {
  .Careers-whyGrid-LVLUZ {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .Careers-sec-jDSqP {
    padding: 44px 0;
  }
  .Careers-grid-gQfzI {
    grid-template-columns: 1fr;
  }
  .Careers-openCard-vRnig {
    padding: 30px 24px;
  }
}

@media (prefers-color-scheme: dark) {
  .Careers-page-TWS86 {
    background: #14171a;
    color: #f3f4f6;
  }
  .Careers-alt-AeRCA {
    background: #1a1e22;
  }
  .Careers-h2-bb89p,
  .Careers-h2Left-iOr11,
  .Careers-cardTitle-vZ4RF,
  .Careers-openBtnAlt-l4CaN {
    color: #f3f4f6;
  }
  .Careers-missionText-dGHGA,
  .Careers-cardText-doWJz,
  .Careers-whyText-AKibF,
  .Careers-openText-Sz3Th {
    color: #9aa3ad;
  }
  .Careers-card-FAsqC,
  .Careers-whyCard-zsnb1 {
    background: #1d2125;
    border-color: #2c3137;
  }
  .Careers-cardIc-FWWAQ {
    background: rgba(232, 35, 43, 0.14);
  }
  .Careers-openCard-vRnig {
    background: rgba(22, 163, 74, 0.12);
    border-color: #2c3137;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/careers/Careers.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,YAAY;;AACZ;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AACA;EACE,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gBAAgB;;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,aAAa;;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,0BAA0B;;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;;;IAIE,cAAc;EAChB;EACA;;;;IAIE,cAAc;EAChB;EACA;;IAEE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 56px 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 28px;\n}\n.h2Left {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n\n/* Mission */\n.mission {\n  max-width: 720px;\n  margin: 0 auto;\n  text-align: center;\n}\n.mission .h2 {\n  margin-bottom: 14px;\n}\n.missionText {\n  font-size: 18px;\n  line-height: 1.65;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Value cards */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n.card {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 22px;\n  background: #fff;\n}\n.cardIc {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: #fff0ef;\n  color: var(--red);\n  margin-bottom: 14px;\n}\n.cardIc svg {\n  width: 26px;\n  height: 26px;\n}\n.cardTitle {\n  font-size: 17px;\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.cardText {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Why grid */\n.whyGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.whyCard {\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 26px 24px;\n  background: #fff;\n}\n.whyTitle {\n  font-size: 18px;\n  font-weight: 800;\n  margin: 0 0 8px;\n  color: var(--red);\n}\n.whyText {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Open application card */\n.openCard {\n  max-width: 720px;\n  margin: 0 auto;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 36px 38px;\n  background: #e4f6f3;\n  text-align: center;\n}\n.openText {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0 0 22px;\n}\n.openActions {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.openBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n  transition: background 0.16s, transform 0.16s;\n}\n.openBtn:hover {\n  background: var(--red-d);\n  transform: translateY(-2px);\n}\n.openBtnAlt {\n  color: var(--ink);\n  font-weight: 700;\n  text-decoration: none;\n  font-size: 15px;\n}\n.openBtnAlt:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 1000px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 760px) {\n  .whyGrid {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 680px) {\n  .sec {\n    padding: 44px 0;\n  }\n  .grid {\n    grid-template-columns: 1fr;\n  }\n  .openCard {\n    padding: 30px 24px;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2,\n  .h2Left,\n  .cardTitle,\n  .openBtnAlt {\n    color: #f3f4f6;\n  }\n  .missionText,\n  .cardText,\n  .whyText,\n  .openText {\n    color: #9aa3ad;\n  }\n  .card,\n  .whyCard {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .cardIc {\n    background: rgba(232, 35, 43, 0.14);\n  }\n  .openCard {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: #2c3137;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Careers-page-TWS86`,
	"wrap": `Careers-wrap-i2dc5`,
	"sec": `Careers-sec-jDSqP`,
	"alt": `Careers-alt-AeRCA`,
	"h2": `Careers-h2-bb89p`,
	"h2Left": `Careers-h2Left-iOr11`,
	"mission": `Careers-mission-JRhdE`,
	"missionText": `Careers-missionText-dGHGA`,
	"grid": `Careers-grid-gQfzI`,
	"card": `Careers-card-FAsqC`,
	"cardIc": `Careers-cardIc-FWWAQ`,
	"cardTitle": `Careers-cardTitle-vZ4RF`,
	"cardText": `Careers-cardText-doWJz`,
	"whyGrid": `Careers-whyGrid-LVLUZ`,
	"whyCard": `Careers-whyCard-zsnb1`,
	"whyTitle": `Careers-whyTitle-Ov88I`,
	"whyText": `Careers-whyText-AKibF`,
	"openCard": `Careers-openCard-vRnig`,
	"openText": `Careers-openText-Sz3Th`,
	"openActions": `Careers-openActions-tz9AB`,
	"openBtn": `Careers-openBtn-QnJBN`,
	"openBtnAlt": `Careers-openBtnAlt-l4CaN`
};
module.exports = ___CSS_LOADER_EXPORT___;
